import { useTranslation } from 'react-i18next';

import { Badge } from '~/vendor/cxy/components/Badge';

import styles from './styles/AiBagde.module.css';

export type AiBadgeProps = {
  description: string;
  projection: number;
  resourcesUrl: string;
};

const AiBadge = ({ description, projection, resourcesUrl }: AiBadgeProps) => {
  const { t } = useTranslation();
  return (
    <Badge className={styles.badge} data-testid="ai-badge" variant="secondary">
      <>
        <img alt="Stars Icon" className={styles.statsIcon} src={`${resourcesUrl}/assets/img/plus/stars.svg`} />
        <span className={styles.ai}>{t('CX_PLUS_AI_PROJECTED')}: </span>
        <span>{projection.toFixed(1)}</span>
        <span>{description}</span>
      </>
    </Badge>
  );
};

export { AiBadge };
